import type { ReactElement } from 'react';
import type { RunStatus } from '../types/agentRun.types';

interface RunStatusBadgeProps {
  status: RunStatus;
}

const STATUS_LABELS: Record<RunStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  succeeded: 'Succeeded',
  failed: 'Failed',
  denied: 'Denied',
  stopped: 'Stopped',
  expired: 'Expired',
};

export function RunStatusBadge({ status }: RunStatusBadgeProps): ReactElement {
  return (
    <span className={`status-badge status-badge--run-${status}`}>
      {status === 'running' && <span className="status-badge__spinner" />}
      {STATUS_LABELS[status]}
    </span>
  );
}
